import { useState } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { Link } from "react-router-dom";
import JuisciLogoSVG from "../../assets/core/icon-square.svg?react";
import CloseIcon from "../../assets/icons/close.svg?react";
import image from "../../assets/images/upload-avatar-modal-image.png";
import { useTranslation } from "react-i18next";

export default function AddProfilePictureModal({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [isClosing, setIsClosing] = useState(false);

  function handleClose() {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  }

  function handleOutsideClick(e: React.MouseEvent<HTMLDivElement>) {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  }

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0    bg-black/80 flex items-center justify-center z-100 md:left-1/2 md:-translate-x-1/2 md:w-[600px] ${isClosing ? "animate-[fadeOut_0.3s_ease-out_forwards]" : "animate-[fadeIn_0.3s_ease-out_forwards]"}`}
      onClick={handleOutsideClick}
    >
      <div
        className={`flex flex-col items-center gap-6 ${isClosing ? "animate-[scaleOut_0.2s_ease-out_forwards]" : "animate-[scaleIn_0.2s_ease-out_forwards]"}`}
      >
        <div className="overflow-hidden rounded-full size-8  flex items-center justify-center">
          <JuisciLogoSVG />
        </div>
        <RemoveScroll enabled={isVisible}>
          <div className="flex flex-col gap-6 p-[22px] w-[75vw] bg-secondary-soft-yellow-1 rounded-2xl relative items-center md:w-[580px] [&_svg]:text-secondary-orange-2 [&_svg]:absolute [&_svg]:top-5 [&_svg]:right-5 [&_img]:size-43.75  [&_img]:mt-[42px] [&_h1]:text-primary-black [&_h1]:text-center [&_h1]:font-dm-sans [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:leading-[140%] [&_h1]:m-0 [&_p]:text-primary-black [&_p]:text-center [&_p]:font-dm-sans [&_p]:text-base [&_p]:font-normal [&_p]:leading-[150%] [&_p]:m-0 [&_button]:p-[16px_24px] [&_button]:border-none [&_button]:rounded-[25px] [&_button]:bg-primary-yellow [&_button]:text-primary-black [&_button]:text-center [&_button]:font-dm-sans [&_button]:text-base [&_button]:font-bold">
            <CloseIcon onClick={handleClose} />
            <img src={image} />
            <h1>{t("Upload your profile picture")}</h1>
            <p>
              {t(
                "Stand out, personalize your experience, and start building valuable connections with peers on Juisci."
              )}
            </p>
            <Link to="/settings/edit/profile/avatar">
              <button>{t("Upload my picture")}</button>
            </Link>
          </div>
        </RemoveScroll>
      </div>
    </div>
  );
}
